import React from "react";
import "./MemberStatusButton.css";

/*

  This is the actual pressable button component that is used in the StatusChanger

  Props

  status : a member's status {"junior","senior","alumni"}. Default is Error.
  OnClickFunction: function to execute on click. no default

*/

function MemberStatusButton({status, onClickFunction, isAdmin}) {
  
    let memberStatus = status
    let id = (isAdmin ? "" : "nonScalable") 

    // we init stylign for custom inline styling later on ( as in two lines lower )
    let styling = {}
    let buttonText; // init button text so we can change it based on status

    //custom styling based on status
    if (isAdmin) {
      styling.cursor="pointer";
    }
    if(memberStatus==="junior") {
        buttonText = "Junior";
        styling.color = "var(--green)";
        styling.borderColor="var(--green)";
    } else if (memberStatus==="senior") {
        buttonText="Senior";
        styling.color = "var(--eestec-red)";
        styling.borderColor="var(--estec-red)";
    } else if (memberStatus==="alumni") {
        buttonText="Alumni";
        styling.color = "var(--burgundy)";
        styling.borderColor="var(--burgundy)";
    } else if (memberStatus==="friend") {
      buttonText="Friend";
      styling.color = "var(--orange)";
      styling.borderColor="var(--orange)";
    } else if (memberStatus==="freezed") {
      buttonText="Freezed";
      styling.color = "var(--light-grey)";
      styling.borderColor="var(--light-grey)";
    } else {
      //if the status isnt junior senior or alumni we default to showing error on gray text
        buttonText="!Error!";
        styling.color = "var(--dark-grey)";
        styling.borderColor="var(--dark-grey)";
    }

    return (
    <button
      id={id}
      className="memberStatusButton"
      style={styling}
      onClick={onClickFunction}
      data-testid="memberStatusButton"
    >
      {buttonText}
    </button>
  );
}

export default MemberStatusButton;
